import "./ServiceLayout.css";

export default function ServiceLayout({ title, subtitle, features, gradient }) {
  return (
    <div className="service-wrapper">

      {/* HERO */}
      <div
        className="service-hero"
        style={{ background: "linear-gradient(135deg,#ff8c00,#ff5e00)" }}
      >
        <h1>{title}</h1>
        <p>{subtitle}</p>
      </div>

      {/* FEATURES */}
      <div className="service-body">
        <h2>What We Provide</h2>

        <div className="feature-grid">
          {features.map((item, index) => (
            <div key={index} className="feature-box">
              <span>✓</span>
              <p>{item}</p>
            </div>
          ))}
        </div>
      </div>

      {/* CTA */}


    </div>
  );
}
